export const EVENT_PROFILE_UPDATE = 'profile.update'
